/*
  CUSTOM (Typeset Co) — store JavaScript, ported from Gem 1.0 assets/theme.js.
  Loaded by snippets/custom.body-end.liquid. Config: window.TypesetCustom.
  See snippets/theme-update-log.liquid.
*/
(function () {
  'use strict';

  var config = window.TypesetCustom || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADDON_HANDLES = ['priority-handling', 'additional-insurance', 'add-signature-confirmation'];

  function formatMoney(cents) {
    var format = config.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var noTrailing = value.replace(/\.00$/, '');
    var withCommas = function (v) {
      var p = v.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return p.join('.');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas(Math.round(cents / 100).toString());
        case 'amount_with_comma_separator': return value.replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return Math.round(cents / 100).toString();
        default: return withCommas(noTrailing);
      }
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* ---------- Free-shipping message (snippets/custom.free-shipping.liquid) ---------- */
  function updateFreeShipping(cart) {
    document.querySelectorAll('.Free_ShippingText').forEach(function (box) {
      var threshold = parseInt(box.getAttribute('data-threshold'), 10);
      if (isNaN(threshold)) return;
      var qualifies = cart.total_price >= threshold;
      box.querySelectorAll('.free-shipping-message').forEach(function (el) { el.style.display = qualifies ? '' : 'none'; });
      box.querySelectorAll('.free-shipping-remaining').forEach(function (el) { el.style.display = qualifies ? 'none' : ''; });
      box.querySelectorAll('.free-shipping-amount').forEach(function (el) {
        el.textContent = formatMoney(Math.max(threshold - cart.total_price, 0));
      });
    });
  }

  /* ---------- Checkout lock: add-ons only / pre-order agreement ---------- */
  function hasPreOrder(cart) {
    return cart.items.some(function (item) {
      return item.properties && Object.keys(item.properties).some(function (key) {
        return key.indexOf('Pre-Order') > -1 || String(item.properties[key]).indexOf('Pre-Order') > -1;
      });
    });
  }

  function updateCheckout(cart) {
    var onlyAddons = cart.items.length > 0 && cart.items.every(function (item) {
      return ADDON_HANDLES.indexOf(item.handle) > -1;
    });
    var preorder = hasPreOrder(cart);

    document.querySelectorAll('.cart__checkout-wrapper').forEach(function (wrapper) {
      var msg = wrapper.querySelector('.pre-order-msg');
      if (preorder && !msg && config.preOrderMessage) {
        msg = document.createElement('div');
        msg.className = 'pre-order-msg';
        var id = 'preorder-item-' + Math.random().toString(36).slice(2, 8);
        msg.innerHTML = '<input type="checkbox" id="' + id + '" name="preorder_item" required><label for="' + id + '"></label>';
        msg.querySelector('label').textContent = config.preOrderMessage;
        wrapper.prepend(msg);
        msg.querySelector('input').addEventListener('change', function () { updateCheckout(cart); });
      } else if (!preorder && msg) {
        msg.remove();
        msg = null;
      }
      var agreed = !msg || msg.querySelector('input').checked;
      wrapper.querySelectorAll('.cart__checkout').forEach(function (btn) {
        btn.disabled = onlyAddons || !agreed;
      });
    });
  }

  function refresh() {
    getCart().then(function (cart) {
      updateFreeShipping(cart);
      updateCheckout(cart);
    }).catch(function () {});
  }

  /* ---------- Add-on upsells (snippets/custom.cart-addons.liquid) ---------- */
  function addAddon(trigger) {
    var id = trigger.getAttribute('data-product-id');
    if (!id) return;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) return Promise.reject(r);
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      setTimeout(refresh, 400);
    }).catch(function (err) {
      console.error('Add-on could not be added to cart', err);
    });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('.addoncheck');
    if (trigger) addAddon(trigger);
  });
  document.addEventListener('keydown', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('.addoncheck');
    if (trigger && (evt.key === 'Enter' || evt.key === ' ')) {
      evt.preventDefault();
      addAddon(trigger);
    }
  });

  ['cart:updated', 'ajaxProduct:added', 'CartDrawer:change', 'cart:open'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(refresh, 300); });
  });

  /* ---------- Personalization fields: product forms are novalidate in Gem 5 ---------- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.querySelector) return;
    var invalid = Array.prototype.find.call(form.querySelectorAll('.custom-fields [required]'), function (el) {
      return !el.value || !el.value.trim();
    });
    if (invalid) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      invalid.reportValidity ? invalid.reportValidity() : invalid.focus();
    }
  }, true);

  /* ---------- Breadcrumb: "back to" the last browsed collection ---------- */
  function updateBreadcrumb() {
    var link = document.querySelector('.js-dynamic-breadcrumb-link');
    if (!link) return;
    try {
      var url = sessionStorage.getItem('last_collection_url');
      var title = sessionStorage.getItem('last_collection_title');
      var allowed = (link.getAttribute('data-product-collections') || '').split(',');
      if (url && title && allowed.indexOf(url) > -1) {
        link.setAttribute('href', url);
        link.textContent = title;
      }
    } catch (e) {}
  }

  /* ---------- Media with text: smooth scroll for #anchor buttons ---------- */
  document.addEventListener('click', function (evt) {
    var a = evt.target.closest && evt.target.closest('.media-with-text__content-button a[href^="#"]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    evt.preventDefault();
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
  });

  function init() {
    updateBreadcrumb();
    if (document.querySelector('.cart__checkout-wrapper, .Free_ShippingText')) refresh();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
